import { gql } from '@apollo/client/core';

export const getBillingSubTypes = gql`
  query {
    contractTypes {
      id
      name
    }
  }
`;
